import React from 'react';
import { ItemAvailability } from '../../ItemAvailability';

interface StoreItemsTabProps {
  storeNumber: string;
}

/**
 * Items/Snoozing tab for store detail view.
 * Wraps the ItemAvailability component.
 */
export const StoreItemsTab: React.FC<StoreItemsTabProps> = ({ storeNumber }) => {
  return <ItemAvailability storeNumber={storeNumber} />;
};
